import { render, staticRenderFns } from "./PrivateHome.vue?vue&type=template&id=36af0917&scoped=true&"
import script from "./PrivateHome.vue?vue&type=script&lang=js&"
export * from "./PrivateHome.vue?vue&type=script&lang=js&"
import style0 from "./PrivateHome.vue?vue&type=style&index=0&id=36af0917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af0917",
  null
  
)

export default component.exports